export default __webpack_public_path__ + "static/media/jackpot9.a13f4ca9.png";